// extracted by mini-css-extract-plugin
export default {"control":"Control_control__OoLmq","button":"Control_button__USUob","approved":"Control_approved__uL5Mu","rejected":"Control_rejected__3Upb+"};